import React, { useEffect } from "react";
import { MessageCircle } from "lucide-react";
import { useShop } from "../context/ShopContext";
import Seo from "../components/Seo";
import LandingShell from "../components/LandingShell";
import { getUtm, trackWithConsent } from "../lib/metaPixel";

// Pagina di arrivo dopo l'invio del form Perfex (impostata come redirect nel
// form in Perfex). Serve anche da evento di conversione "Lead" per Meta.
const WHATSAPP = "https://wa.me/393298044265";

const content = {
  it: {
    seoTitle: "Ricevuto! Ti scrivo io",
    title: "Ricevuto!",
    text: "Ti scrivo io, di solito entro la giornata. Nel frattempo, se vuoi, scrivimi su WhatsApp.",
    cta: "Scrivimi su WhatsApp",
    name: "— Christian Mino, IdeaMedia",
  },
  en: {
    seoTitle: "Got it! I'll be in touch",
    title: "Got it!",
    text: "I'll write to you, usually within the day. In the meantime, if you like, message me on WhatsApp.",
    cta: "Message me on WhatsApp",
    name: "— Christian Mino, IdeaMedia",
  },
};

const AnalisiGoogleGrazie = () => {
  const { lang } = useShop();
  const c = content[lang];
  const events = [["PageView"], ["Lead", { content_name: "analisi-google", ...getUtm() }]];

  useEffect(() => { trackWithConsent(events); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <LandingShell pixelEvents={events}>
      <Seo title={c.seoTitle} image="/images/og-analisi-google.jpg" noindex />
      <main className="idm-lp-wrap idm-lp-thanks" data-testid="analisi-google-grazie">
        <div className="idm-lp-trust idm-lp-trust-big">
          <img src="/images/christian-56.webp" alt="Christian Mino" width="56" height="56" />
        </div>
        <h1>{c.title}</h1>
        <p className="idm-lp-sub">{c.text}</p>
        <a className="idm-lp-wa" href={WHATSAPP} target="_blank" rel="noreferrer" data-testid="thanks-whatsapp">
          <MessageCircle size={22} aria-hidden="true" /> {c.cta}
        </a>
        <p className="idm-lp-sign">{c.name}</p>
      </main>
    </LandingShell>
  );
};

export default AnalisiGoogleGrazie;
